import React, { useEffect, useState } from "react";

const Level1DivisionFun = () => {
  let problems = [
  { question: "36 ÷ 4", hint: "🧠 Hint: 32 ÷ 4 + 4 ÷ 4", answer: 9 },
  { question: "45 ÷ 5", hint: "🧠 Hint: 40 ÷ 5 + 5 ÷ 5", answer: 9 },
  { question: "56 ÷ 7", hint: "🧠 Hint: 49 ÷ 7 + 7 ÷ 7", answer: 8 },
  { question: "81 ÷ 9", hint: "🧠 Hint: 81 ÷ 9 (think of 9×9)", answer: 9 },
  { question: "72 ÷ 8", hint: "🧠 Hint: 64 ÷ 8 + 8 ÷ 8", answer: 9 },
  { question: "144 ÷ 6", hint: "🧠 Hint: 120 ÷ 6 + 24 ÷ 6", answer: 24 },
  { question: "225 ÷ 5", hint: "🧠 Hint: 200 ÷ 5 + 25 ÷ 5", answer: 45 },
  { question: "324 ÷ 3", hint: "🧠 Hint: 300 ÷ 3 + 24 ÷ 3", answer: 108 },
  { question: "168 ÷ 4", hint: "🧠 Hint: 160 ÷ 4 + 8 ÷ 4", answer: 42 },
  { question: "252 ÷ 6", hint: "🧠 Hint: 240 ÷ 6 + 12 ÷ 6", answer: 42 },
  { question: "189 ÷ 3", hint: "🧠 Hint: 180 ÷ 3 + 9 ÷ 3", answer: 63 },
  { question: "196 ÷ 7", hint: "🧠 Hint: 140 ÷ 7 + 56 ÷ 7", answer: 28 },
  { question: "108 ÷ 6", hint: "🧠 Hint: 60 ÷ 6 + 48 ÷ 6", answer: 18 },
  { question: "225 ÷ 9", hint: "🧠 Hint: 180 ÷ 9 + 45 ÷ 9", answer: 25 },
  { question: "315 ÷ 5", hint: "🧠 Hint: 300 ÷ 5 + 15 ÷ 5", answer: 63 }
];

  const shuffle = (array) => {
    let currentIndex = array.length,
      randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }
    return array;
  };

  let shuffledProblems = problems;
  const [currentProblemIndex, setCurrentProblemIndex] = useState(0);
  const [feedback, setFeedback] = useState("");

  useEffect(() => {
    loadQuestion();
    // eslint-disable-next-line
  }, [currentProblemIndex]);

  function loadQuestion() {
    const problem = shuffledProblems[currentProblemIndex];
    document.getElementById(
      "question"
    ).innerHTML = `<h2>🤔 ${problem.question} = ?</h2>`;
    document.getElementById("hint").innerText = problem.hint;
    setFeedback("");
    document.getElementById("userAnswer").value = "";
  }

  function checkAnswer() {
    const userInput = parseInt(document.getElementById("userAnswer").value);
    const correctAnswer = shuffledProblems[currentProblemIndex].answer;

    if (userInput === correctAnswer) {
      document.getElementById("correctSound").play();
      setFeedback("🎉✅ Correct! You rock!");

      if (currentProblemIndex < shuffledProblems.length - 1) {
        setTimeout(() => setCurrentProblemIndex((prev) => prev + 1), 2000);
      } else {
        setFeedback("🏁🎊 You’ve completed all Level 1 problems!");
      }
    } else {
      document.getElementById("wrongSound").play();
      setFeedback("❌ Oops! Try again!");
    }
  }

  const goNext = () => {
    if (currentProblemIndex < shuffledProblems.length - 1) {
      setCurrentProblemIndex((prev) => prev + 1);
    }
  };

  const goPrevious = () => {
    if (currentProblemIndex > 0) {
      setCurrentProblemIndex((prev) => prev - 1);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Fredoka One', cursive",
        background: "linear-gradient(120deg, #a1c4fd, #fbc2eb)",
        textAlign: "center",
        padding: "40px",
        minHeight: "100vh",
        color: "#333",
      }}
    >
      <h1
        style={{
          fontSize: "2.5em",
          color: "#ff4081",
          marginBottom: "30px",
        }}
      >
        🎓 Level 1: Long Division Fun! 🧮
      </h1>

      <div
        className="question-box"
        style={{
          background: "#ffffff",
          border: "6px dotted #ff4081",
          borderRadius: "25px",
          padding: "40px",
          width: "60%",
          margin: "20px auto",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          animation: "bounce 1s ease infinite alternate",
        }}
      >
        <div id="question"></div>
        <div
          className="hint"
          id="hint"
          style={{ fontSize: "1rem", color: "#666", marginBottom: "20px" }}
        ></div>

        {/* Centered Input and Buttons */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <input
            type="number"
            id="userAnswer"
            style={{
              padding: "12px",
              fontSize: "1.4rem",
              width: "120px",
              border: "3px solid #ff4081",
              borderRadius: "10px",
              marginTop: "10px",
            }}
          />
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={goPrevious}
              style={{
                padding: "10px 20px",
                fontSize: "1.1rem",
                backgroundColor: "#42a5f5",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
              }}
              disabled={currentProblemIndex === 0}
            >
              ⬅️ Previous
            </button>
            <button
              onClick={checkAnswer}
              style={{
                padding: "12px 25px",
                fontSize: "1.2rem",
                backgroundColor: "#ff4081",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
              }}
            >
              ✅ Submit
            </button>
            <button
              onClick={goNext}
              style={{
                padding: "10px 20px",
                fontSize: "1.1rem",
                backgroundColor: "#66bb6a",
                color: "white",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
              }}
              disabled={currentProblemIndex === shuffledProblems.length - 1}
            >
              Next ➡️
            </button>
          </div>
        </div>

        <div
          className="feedback"
          id="feedback"
          style={{
            fontSize: "1.5rem",
            marginTop: "20px",
            fontWeight: "bold",
            color: feedback.includes("Correct") ? "green" : feedback.includes("Oops") ? "red" : "#333",
          }}
        >
          {feedback}
        </div>
      </div>

      <audio
        id="correctSound"
        src="https://www.soundjay.com/human/kids-cheering-01.mp3"
      ></audio>
      <audio
        id="wrongSound"
        src="https://www.soundjay.com/button/beep-10.mp3"
      ></audio>

      <style>{`
        @keyframes bounce {
          from { transform: translateY(0px); }
          to { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default Level1DivisionFun;
